export const RAKEBACK_INFO = [
  {
    title: 'bonusCabinet.rakeBack.1.title',
    answer: ['bonusCabinet.rakeBack.1.subTitle'],
  },
  {
    title: 'bonusCabinet.rakeBack.2.title',
    answer: ['bonusCabinet.rakeBack.2.subTitle'],
  },
  {
    title: 'bonusCabinet.rakeBack.3.title',
    answer: ['bonusCabinet.rakeBack.3.subTitle'],
  },
  {
    title: 'bonusCabinet.rakeBack.4.title',
    answer: ['bonusCabinet.rakeBack.4.subTitle'],
  },
];
